import { useEffect, useState } from 'react';
import { Link, Redirect } from 'react-router-dom';

import { Cargando, Error } from '../shared';

import { getImponible, unMount } from './ctaCtoAxios';

import "./optionpayment.scss";
import { useHistory } from 'react-router';

export const CuotasPagar = ({
  location: {
    state: { tipo, data, titles },
  },
}) => {
  console.log("props", [tipo, data, titles]);
  console.log(data);
  console.log(titles);


  const [imponible, setImponible] = useState(null);
  const [etapa, setEtapa] = useState('dos')

  let history = useHistory();
  useEffect(() => {
    if (!data) {
      history.push("/apps/inmueble/inmuebles");
    }
    unMount(tipo, data, setImponible, setEtapa)
  }, [data, tipo]);


  if (imponible === null) return <Cargando />;

  if (imponible.error) return <Error msg={'Por favor, verifique los datos ingresados.'} />;
  // console.log(imponible);

  if (imponible?.estado_complementario === 'Caducado') return <Error msg={'El plan de pago Nro ' + data + ' se encuentra caducado por favor comunicarse al mail facilidades@muninqn.gov.ar'} />;

  if (imponible?.estado_complementario === 'Cancelado') return <Error msg={'El plan de pago Nro ' + data + ' se encuentra cancelado por favor comunicarse al mail facilidades@muninqn.gov.ar'} />;

  /* return (
    <Redirect
      to={{
        pathname: "/apps/inmueble/pagar-mensual/",
        state: { imponible, titles, tipo },
      }}
    />
  ); */
  console.log(imponible);

  return (
    <div className="container">
      <div className="row mt-5">
        <h2 className="text-center pt-3">Seleccione una opción</h2>

        {etapa !== 'dos' &&
          <div className="col col-md-12 text-center">
            <Link
              to={{
                pathname: "/apps/inmueble/pagar-semestral/",
                state: { imponible, tipo, titles },
              }}
              className="btn btn-form active text-uppercase m-4"
            >
              Generar recibos semestre 2026
            </Link>
          </div>}

        {etapa === 'dos' &&
          <div className="col col-md-12 text-center">
            <Link
              to={{
                pathname: "/apps/inmueble/pagar-anticipado-primer-semestre/",
                state: { imponible, tipo, titles },
              }}
              className="btn btn-form active text-uppercase m-4"
            >
              Generar recibo anticipado primer semestre 2026
            </Link>
          </div>}

        {etapa === 'dos' &&
          <div className="col col-md-12 text-center">
            <Link
              to={{
                pathname: "/apps/inmueble/pagar-mensual-2026/",
                state: { imponible, tipo, titles },
              }}
              className="btn btn-form active text-uppercase m-4"
            >
              Generar recibos mensuales 2026
            </Link>
          </div>}


        <div className="col col-md-12 text-center">
          <Link
            to={{
              pathname: "/apps/inmueble/pago-contado-50-desc/",
              state: { imponible, tipo, titles },
            }}
            className="btn btn-form active text-uppercase m-4"
          >
            Pago contado 50% de desc. sobre intereses
          </Link>
        </div>

        <div className="col col-md-12 text-center">
          <Link
            to={{
              pathname: "/apps/inmueble/pagar-mensual/",
              state: { imponible, tipo, titles },
            }}
            className="btn btn-form active text-uppercase m-4"
          >
            Generar recibos anteriores
          </Link>
        </div>

        {/* <div className="col col-md-12 text-center">
              <Link
                to={{
                  pathname: "/apps/inmueble/pago-anticipado/",
                  state: { imponible, tipo },
                }}
                className="btn btn-form active text-uppercase m-4"
              >
                Pago anticipado segundo semestre
              </Link>
          </div> */}
        <div className="col-12 text-center mt-1">
          <Link
            to="/apps/inmueble"
            className="btn btn-form active mb-1 text-center"
          >
            SALIR
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CuotasPagar;
